module.exports = __webpack_public_path__ + "static/media/udacity_logo.918d6ecc.png";